import { createRoutes } from '@dadohr/shared/domainTypes/routes';
import queryString from 'query-string';
import ENV from '../../../env.json';

export const getAppUrl = () => {
  const p = ENV.domains.app;
  return import.meta.env.DEV ? p.local : p.public;
};

export const ROUTES = (orgId: string) =>
  createRoutes(
    (path, query) => ({
      path: `${getAppUrl()}${path}`,
      query: { ...(query || {}), orgId }
    }),
    queryString.stringify
  );
